import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useI18n } from "@/i18n";

export default function PaymentCancel() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-[#1F1A14] text-[#FAF9F6] flex items-center justify-center px-4 grain" data-testid="payment-cancel-page">
      <div className="max-w-xl text-center py-24">
        <XCircle className="w-14 h-14 mx-auto text-[#C85A3C]" strokeWidth={1.2} />
        <p className="mt-8 overline text-[#C85A3C]">Stripe</p>
        <h1 className="font-serif-display text-5xl md:text-6xl mt-4 leading-[1.05]" data-testid="payment-cancel-title">
          {t.booking.cancelTitle}
        </h1>
        <p className="mt-6 text-[#FAF9F6]/70 text-lg leading-relaxed">
          {t.booking.cancelSub}
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/#booking"
            data-testid="payment-retry"
            className="btn-terracotta px-8 py-4 rounded-sm tracking-[0.2em] uppercase text-xs"
          >
            {t.booking.retry}
          </Link>
          <Link
            to="/"
            data-testid="payment-back-home"
            className="text-xs tracking-widest uppercase text-[#FAF9F6]/60 hover:text-[#C85A3C] border-b border-[#FAF9F6]/20 pb-1"
          >
            {t.booking.backHome}
          </Link>
        </div>
      </div>
    </div>
  );
}
